export function fetchTCodes(_ref) {
  var state = _ref.state,
    dispatch = _ref.dispatch;
  if (state.tCodeOptions.length === 0) {
    return dispatch('api', {
      url: 't-codes',
      commitAfter: 'tCodes/SET_T_CODES',
      wait: 'fetch-t-codes'
    }, {
      root: true
    });
  }
}
export function getTCodesByCuiNGrams(_ref2, nGrams) {
  var state = _ref2.state,
    dispatch = _ref2.dispatch;
  return dispatch('api', {
    url: 't-codes/cui-n-grams',
    params: {
      n_grams: nGrams
    }
  }, {
    root: true
  });
}